import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import { ModelsTable } from '../../Models/ModelsTable';

export const AssetModelsTab = () => {
  const { assetId } = useParams();
  const { t } = useTranslation();

  return (
    <div
      className="asset-models-content anim-slideInUpShort"
      data-testid="asset-models-content"
      style={{ margin: '1rem' }}
    >
      <TextComponent variant="headerSmall" color="muted" component="h2" mb="1rem">
        {t('page.asset.models.title')}
      </TextComponent>
      <div className="actions-placeholder" />
      <ModelsTable assetId={assetId} />
    </div>
  );
};
